// src/components/JobView/ConfirmDialog.js
// Diálogo de confirmación PROPIO del sistema (reemplaza window.confirm para no mostrar
// el "<dominio> says" del navegador). Muestra un título, un cuerpo libre (children) y
// botones Confirmar/Cancelar. Reutilizable (descargar JSON, guardar, cambiar estado…).
import React from "react";
import { X } from "lucide-react";

const ConfirmDialog = ({
  open,
  title = "Confirmar",
  children,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  onConfirm,
  onCancel,
  tone = "primary", // 'primary' | 'danger' | 'success'
  busy = false,
}) => {
  if (!open) return null;
  const toneCls = {
    primary: "bg-blue-600 hover:bg-blue-700",
    danger: "bg-red-600 hover:bg-red-700",
    success: "bg-emerald-600 hover:bg-emerald-700",
  }[tone] || "bg-blue-600 hover:bg-blue-700";

  return (
    <div className="fixed inset-0 z-[130] bg-black bg-opacity-60 flex items-center justify-center p-4" onClick={onCancel}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <header className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-bold text-gray-800">{title}</h3>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-700"><X size={20} /></button>
        </header>
        <div className="p-5 overflow-y-auto text-sm text-gray-700">{children}</div>
        <footer className="flex justify-end gap-2 p-4 border-t bg-gray-50">
          <button onClick={onCancel} disabled={busy} className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold text-sm disabled:opacity-50">{cancelText}</button>
          <button onClick={onConfirm} disabled={busy} className={`px-5 py-2 rounded-lg text-white font-bold text-sm disabled:opacity-50 ${toneCls}`}>{busy ? "…" : confirmText}</button>
        </footer>
      </div>
    </div>
  );
};

export default ConfirmDialog;
